import {Component, Prop, Watch} from 'vue-property-decorator';
import {VuexObjectMixin} from './VuexObjectMixin';
import {Product, Slot, TicketConfiguration, TicketConfigurationCollection} from '../Models';

@Component
export class TicketConfigurationMixin extends VuexObjectMixin {
  @Prop({type: Array, required: true}) productsProp: Array<Product> | undefined;
  @Prop({type: Array, required: true}) slotsProp: Array<Slot> | undefined;
  @Prop({type: Object, required: true}) onSiteProducts: { sb: Product | null, helpdesk: Product | null } | undefined;

  protected findProduct(id: number): Product | null {
    let prod: Product | null | undefined = null;
    if (this.productsProp) {
      prod = this.productsProp.find((p) => p.id === id);
    }

    if (!prod) {
      return null;
    }
    return prod;
  }

  protected incrementQuantity(ticketConfiguration: TicketConfiguration | TicketConfigurationCollection): void {
    this.$emit('incrementQuantity', ticketConfiguration);
  }

  protected decrementQuantity(ticketConfiguration: TicketConfiguration| TicketConfigurationCollection): void {
    this.$emit('decrementQuantity', ticketConfiguration);
  }
}
